import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const SeguroService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'seguro/excel/deletar', 'excelSeguroDeletar');
    },
    enviarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'seguro/excel', 'excelMipDfi');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('seguro/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('seguro/eventGrid', {});
    }
}

export default SeguroService;